import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { useSelector } from 'react-redux';
import { organizationSelector } from 'state/selectors/organization';
import styled from 'styled-components';
import get from 'lodash/get';

const StyledEstCostTooltip = styled.div`
  padding: ${SIZES.small};
  width: 45rem;
  & > header {
    display: flex;
    align-items: center;
    font-size: ${SIZES.large};
    font-weight: bold;
    color: ${getColor('shuttleGray')};
    margin-bottom: ${SIZES.small};
    & > svg#Cash {
      margin-right: ${SIZES.small};
    }
  }
`;

const EstCostTooltip = () => {
  const organization = useSelector(organizationSelector);
  const orgName = get(organization, 'name', 'your organization');
  return (
    <StyledEstCostTooltip>
      <header>
        <Icon name='Cash' />
        Estimated cost
      </header>
      Estimated cost applies the average salary per employee (as provided by{' '}
      {orgName}) to the FTE number for your projects/epics/issue types. This
      will show the estimated cost of employee resources working on your
      initiatives during the time period you are viewing.
    </StyledEstCostTooltip>
  );
};

export default EstCostTooltip;
